<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
      @printData="printData"
      @exportExcelData="exportExcelData"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <div v-if="allow('E')">
            <el-badge :value="checkedCount" class="ml-2">
              <b-button
                :disabled="!checkedCount"
                size="sm"
                variant="outline-primary"
                class="printer-button"
                :class="{ clearable: !!checkedCount }"
                @click="batchPrintData(form)"
              >
                <i class="el-icon-printer" />
                {{ $l('INDEX.btn_print') || '打印' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </div>
          <div v-if="allow('EX')">
            <el-badge :value="checkedCount" class="ml-3">
              <b-button
                :disabled="!checkedCount"
                size="sm"
                variant="outline-primary"
                class="printer-button"
                :class="{ clearable: !!checkedCount }"
                @click="batchExportData(form)"
              >
                <i class="el-icon-download" />
                {{ $l('btn_export') || '导出面料检验报告' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </div>
        </template>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @confirmClose="clearCheckboxRow"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseTemplate from '@/views/factory/transport/shipmentDetailQuery/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'factory-fabricInspection',
        searchForm: {},
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .fabricInspectionListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'quality-fabricInspectionReport-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async batchPrintData() {
      const listCode = this.checkedRow.map((e) => e.inspectionCode)
      this.chooseTemplateOptions.searchForm = {
        // ...form,
        listCode,
      }
      this.exportData({ exportType: 'print' })
    },
    async batchExportData() {
      const listCode = this.checkedRow.map((e) => e.inspectionCode)
      this.chooseTemplateOptions.searchForm = {
        // ...form,
        listCode,
      }
      this.exportData({ exportType: 'export' })
    },
    printData(data) {
      this.chooseTemplateOptions.searchForm = {
        listCode: [data.inspectionCode],
        type: data.type || '',
      }
      this.exportData({ exportType: 'print' })
    },
    exportExcelData(data) {
      this.chooseTemplateOptions.searchForm = {
        listCode: [data.inspectionCode],
        type: data.type || '',
      }
      this.exportData({ exportType: 'export' })
    },
    async exportData(params) {
      this.loadingOpen()
      const taskName = params.exportType === 'print' ? 'factory-fabricInspection'  : 'factory-excel-fabricInspection'
      const context = {
        customerExportTemplateCode:
          params.exportType === 'print'
            ? 'e9e88d70-fa74-11f0-a362-000c29540cfd'
            : 'b316a4fa-9d14-11f1-a59c-000c29f334df',
        searchForm: this.chooseTemplateOptions.searchForm,
      }
      const exportRes = await this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .catch(() => null)
      this.loadingClose()
      const { status: exportStatus } = exportRes || {}
      if (200 !== exportStatus) {
        this.$message.error(
          this.$l('INDEX.Description_Failed_to_add_export_task') ||
            '导出任务添加失败',
        )
        return
      }
      this.$message({
        message:
          this.$l('INDEX.added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
      this.clearCheckboxRow()
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
